'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChemSpectraClient = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _index = require('./reducers/index');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('./sagas/index');

var _index4 = _interopRequireDefault(_index3);

var _frame = require('./frame');

var _frame2 = _interopRequireDefault(_frame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// - - - store & middleware - - -
var sagaMiddleware = (0, _reduxSaga2.default)();
// import PropTypes from 'prop-types';
// import { logger } from 'redux-logger';

var middlewares = [sagaMiddleware]; // logger

var store = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares))(_redux.createStore)(_index2.default);

sagaMiddleware.run(_index4.default);

// - - - React - - -
var ChemSpectraClient = function ChemSpectraClient(_ref) {
  var editorOnly = _ref.editorOnly;
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_frame2.default, { editorOnly: editorOnly })
  );
};

ChemSpectraClient.propTypes = {
  editorOnly: _propTypes2.default.bool
};

ChemSpectraClient.defaultProps = {
  editorOnly: false
};

exports.ChemSpectraClient = ChemSpectraClient; // eslint-disable-line